<script>
import AuthSidebar from "../components/AuthSidebar.vue";
import { post } from "../api/Services";
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { mapState, mapActions } from "vuex";
import { Toast } from "primevue/toast";


export default {
  name: "ResetPassword",
  components: {
    AuthSidebar,
    Toast,
  },
  data() {
    return {
      email: "",
      display: false,
      message: "",
      isMailConfirmed: false,
      severity: "",
      uyari: "",
      code: "",
      step: 0,
      submitted: false,
      password: "",
      confirmPassword: "",
      user: {},
    };
  },
  validations: {
    password: {
      required,
    },
    confirmPassword: {
      required,
    },
    code: {
      required,
    },
    email: {
      required,
    },
  },
  setup: () => ({ v$: useVuelidate() }),

  methods: {
    ...mapActions("account", ["logout"]),
    async sentEmail() {
      this.submitted = true;
      if (this.v$.email.$invalid) {
        return;
      }

      this.user.sqlId = 58;
      let parameters = [
        {
          parameter_name: "piv_email",
          parameter_value: this.email.replace(/\s/g, ""),
        },
      ];
      this.user.parameters = JSON.stringify(parameters);

      await post("Commons/Executer", this.user)
        .then((data) => {
          if (data[0].status == 0) {
            this.message = data[0].message;
            this.severity = "success";
            this.isMailConfirmed = true;
            this.step = 1;
            this.submitted = false;
          } else {
            this.isMailConfirmed = true;
            this.step = 1;
            this.submitted = false;
          }
        })
        .catch((error) => {
          this.message = error;
          this.severity = "error";
          this.isMailConfirmed = true;
          this.step = 1;
          this.submitted = false;
        });
    },
    async ResetPassword(valid) {
      this.submitted = true;
      if (!valid) {
        return;
      }
      if (this.password != this.confirmPassword) {
        document.getElementById("confirmPassword").focus();
        document.getElementById("confirmPassword").classList.add("p-invalid");
        this.message = "Passwords do not match";
        this.severity = "error";
        this.isMailConfirmed = true;
        return;
      }
      let parameters = {
        userId: this.account?.loggeduser?.id ? this.account.loggeduser.id : -1,
        email: this.email.replace(/\s/g, ""),
        code: this.code.replace(/\s/g, ""),
        password: this.password,
      };
      this.user.parameters = JSON.stringify(parameters);

      await post("Users/ResetPassword", this.user.parameters)
        .then((data) => {
          if (data[0].status == 0) {
            this.message = data[0].message;
            this.severity = "success";
            this.isMailConfirmed = true;
            this.step = 2;
          } else {
            this.message = data[0].message;
            this.severity = "error";
            this.isMailConfirmed = true;
          }
        })
        .catch((error) => {
          this.message = error;
          this.severity = "error";
          this.isMailConfirmed = true;
        });
    },
    revertSeoUrl(seoUrl) {
      return seoUrl
        .toString()                      // Ensure the input is a string
        .replace(/-/g, ' ')              // Replace hyphens with spaces
        .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
    },
    async MailPasswordReset(valid) {
      this.submitted = true;
      if (this.step == 0) {
        if (this.v$.email.$invalid || this.v$.code.$invalid) {
          return;
        } else {
          this.submitted = false;
          this.step = 1;
        }
      } else if (this.step == 1) {
        this.submitted = false;
        await this.ResetPassword(valid);
      }
    },
    resetFormFields() {
      this.password = "";
      this.confirmPassword = "";
      this.code = "";
      this.submitted = false;
      this.v$.$reset();
    },
    goToLogin() {
      if (this.account?.loggeduser) {
        this.$store.dispatch("auth/logout");
      }
      this.$router.push({ name: 'login' });
    },
  },
  computed: {
    ...mapState({
      account: (state) => state.account,

    }),
  },
  created() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
  },
};
</script>
<template>
  <Toast />
  <div class="reset-password-container">
    <div class="sidebar-container d-none d-lg-block">
      <AuthSidebar />
    </div>

    <div class="content-container">
      <div class="auth-card">
        <div class="logo-container">
          <img
            loading="lazy"
            src="/img/logo.svg"
            alt="CrowdHrs"
            title="CrowdHrs"
            class="form-logo"
          />
        </div>
        
        <div v-if="isMailConfirmed" class="notification" :class="severity">
          <span class="notification-text">{{ revertSeoUrl(message) }}</span>
          <button class="notification-close" @click="isMailConfirmed = false">×</button>
        </div>

        <!-- Progress steps -->
        <div class="progress-steps">
          <div class="step" :class="{ active: step === 0, completed: step > 0 }">
            <div class="step-number">1</div>
            <div class="step-label">Verification</div>
          </div>
          <div class="step-connector" :class="{ 'connector-active': step > 0 }"></div>
          <div class="step" :class="{ active: step === 1, completed: step > 1 }">
            <div class="step-number">2</div>
            <div class="step-label">New Password</div>
          </div>
          <div class="step-connector" :class="{ 'connector-active': step > 1 }"></div>
          <div class="step" :class="{ active: step === 2, completed: step > 2 }">
            <div class="step-number">3</div>
            <div class="step-label">Completed</div>
          </div>
        </div>

        <form class="form-fields" @submit.prevent="
          this.$route.query.email
            ? MailPasswordReset(!v$.$invalid)
            : step === 0
              ? sentEmail(!v$.$invalid)
              : step === 1
                ? ResetPassword(!v$.$invalid)
                : null
        ">
          <!-- Step 0: Email & Code verification -->
          <div v-if="step === 0" class="form-step">
            <div class="form-group">
              <span class="p-float-label">
                <InputText 
                  id="email" 
                  type="email"
                  v-model="v$.email.$model"
                  :class="{ 'input-error': v$.email.$invalid && submitted }"
                  class="w-100"
                />
                <label for="email">Email Address</label>
              </span>
              <small v-if="v$.email.$invalid && submitted" class="error-text">Email is required</small>
            </div>

            <div v-if="this.$route.query.email" class="form-group">
              <span class="p-float-label">
                <InputText 
                  id="code" 
                  type="text"
                  v-model="v$.code.$model"
                  :class="{ 'input-error': v$.code.$invalid && submitted }"
                  class="w-100"
                />
                <label for="code">Verification Code</label>
              </span>
              <small v-if="v$.code.$invalid && submitted" class="error-text">Code is required</small>
            </div>

            <div class="form-actions">
              <Button 
                type="submit" 
                :label="this.$route.query.email ? 'Verify Code' : 'Send Reset Link'" 
                class="chrs-btn-secondary w-100"
              />
            </div>
          </div>

          <!-- Step 1: New Password -->
          <div v-if="step === 1" class="form-step">
            <div v-if="!this.$route.query.email" class="form-group">
              <span class="p-float-label">
                <InputText 
                  id="code" 
                  type="text"
                  v-model="v$.code.$model"
                  :class="{ 'input-error': v$.code.$invalid && submitted }"
                  class="w-100"
                />
                <label for="code">Verification Code</label>
              </span>
              <small v-if="v$.code.$invalid && submitted" class="error-text">Code is required</small>
            </div>

            <div class="form-group">
              <span class="p-float-label">
                <Password 
                  id="password" 
                  v-model="v$.password.$model"
                  class="w-100"
                  inputClass="w-100"
                  :class="{ 'input-error': v$.password.$invalid && submitted }"
                  toggleMask
                  :feedback="true"
                />
                <label for="password">New Password</label>
              </span>
              <small v-if="v$.password.$invalid && submitted" class="error-text">Password is required</small>
            </div>

            <div class="form-group">
              <span class="p-float-label">
                <Password 
                  id="confirmPassword"
                  v-model="v$.confirmPassword.$model"
                  class="w-100"
                  inputClass="w-100"
                  :class="{ 'input-error': v$.confirmPassword.$invalid && submitted }"
                  toggleMask
                  :feedback="false"
                />
                <label for="confirmPassword">Confirm Password</label>
              </span>
              <small v-if="v$.confirmPassword.$invalid && submitted" class="error-text">Confirmation is required</small>
            </div>

            <div class="form-actions">
              <Button 
                type="button" 
                label="Back" 
                class="secondary-button" 
                @click="() => { step--; resetFormFields(); }" 
              />
              <Button 
                type="submit" 
                label="Reset Password" 
                class="chrs-btn-secondary"
              />
            </div>
          </div>

          <!-- Step 2: Success Screen -->
          <div v-if="step === 2" class="form-step success-step">
            <div class="success-icon">
              <i class="pi pi-check-circle"></i>
            </div>
            <h2 class="success-title">Password Reset Successful!</h2>
            <p class="success-message">Your password has been reset successfully. You can now login with your new password.</p>
            
            <div class="form-actions">
              <Button 
                type="button" 
                label="Go to Login" 
                class="chrs-btn-secondary w-100" 
                @click="goToLogin" 
              />
            </div>
          </div>

          <div class="form-footer" v-if="step !== 2">
            <router-link to="/login" class="back-to-login">Back to Login</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.reset-password-container {
  display: flex;
  min-height: 100vh;
  width: 100%;
  background-color: #f7f9fc;
}

.sidebar-container {
  flex: 0 0 33.333%;
  height: 100vh;
}

.content-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.auth-card {
  width: 100%;
  max-width: 550px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  padding: 2rem;
  margin: 0 auto;
  transition: all 0.2s ease;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.form-logo {
  max-width: 180px;
  height: auto;
}

.notification {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  margin-bottom: 1.5rem;
  
  &.success {
    background-color: rgba(40, 167, 69, 0.1);
    border-left: 3px solid #28a745;
    color: #28a745;
  }
  
  &.error {
    background-color: rgba(220, 53, 69, 0.1);
    border-left: 3px solid #dc3545;
    color: #dc3545;
  }
  
  .notification-close {
    background: transparent;
    border: none;
    font-size: 1.25rem;
    cursor: pointer;
    color: inherit;
  }
}

.progress-steps {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  
  .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .step-number {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: #e9ecef;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.5rem;
      font-weight: 600;
      transition: all 0.3s;
    }
    
    .step-label {
      font-size: 0.85rem;
      color: #6c757d;
    }
    
    &.active {
      .step-number {
        background-color: #fc6c2a;
        color: white;
      }
      
      .step-label {
        color: #fc6c2a;
        font-weight: 600;
      }
    }
    
    &.completed {
      .step-number {
        background-color: #28a745;
        color: white;
      }
    }
  }
  
  .step-connector {
    flex: 1;
    height: 3px;
    background-color: #e9ecef;
    margin: 0 1rem;
    margin-bottom: 2rem;
    transition: all 0.3s;
    
    &.connector-active {
      background-color: #28a745;
    }
  }
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-step {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin-bottom: 0 !important;
  
  ::v-deep(.p-float-label) {
    display: block;
    width: 100%;
    margin-bottom: 0.25rem;
    
    label {
      color: #6c757d;
    }
    
    input:focus ~ label,
    .p-inputwrapper-focus ~ label {
      color: #015cac;
    }
  }
  
  ::v-deep(:not(.p-dropdown) .p-inputtext),
  ::v-deep(.p-password input) {
    width: 100% !important;
    padding: 0.75rem;
    font-size: 1rem;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 6px;
    transition: all 0.25s;
    box-sizing: border-box;
    
    &:hover {
      border-color: #fc6c2a;
    }
    
    &:focus {
      border-color: #fc6c2a;
      box-shadow: 0 0 0 2px rgba(252, 108, 42, 0.2);
    }
    
    &.input-error {
      border-color: #dc3545;
      
      &:focus {
        box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25);
      }
    }
  }
  
  .error-text {
    color: #dc3545;
    margin-top: 0.25rem;
    font-size: 0.8rem;
  }
}

::v-deep(.p-password) {
  width: 100%;
  
  .p-password-panel {
    margin-top: 0.5rem;
  }
}

.form-actions {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
  
  .secondary-button {
    height: 48px;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
    border-radius: 6px;
    color: #495057;
    font-weight: 500;
    transition: all 0.3s;
    
    &:hover {
      background-color: #e9ecef;
    }
  }
  
  ::v-deep(.chrs-btn-secondary) {
    flex: 1;
    height: 48px;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.25s ease;
    background-color: #fc6c2a;
    border-color: #fc6c2a;
    
    &:hover {
      background-color: darken(#fc6c2a, 5%);
      border-color: darken(#fc6c2a, 5%);
    }
    
    &:focus {
      box-shadow: 0 0 0 2px rgba(252, 108, 42, 0.2);
    }
  }
}

.form-footer {
  margin-top: 1.5rem;
  text-align: center;
  
  .back-to-login {
    color: #015cac;
    text-decoration: none;
    font-size: 0.9rem;
    font-weight: 500;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

.success-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1rem 0;
  
  .success-icon {
    font-size: 3.5rem;
    color: #28a745;
    margin-bottom: 1rem;
  }
  
  .success-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1rem;
  }
  
  .success-message {
    font-size: 1rem;
    color: #6c757d;
    margin-bottom: 2rem;
    max-width: 400px;
  }
  
  .form-actions {
    width: 100%;
    max-width: 250px;
  }
}

@media (max-width: 991.98px) {
  .reset-password-container {
    flex-direction: column;
  }
  
  .content-container {
    min-height: 100vh;
    padding: 2rem 1rem;
  }
}
</style>
